import { render, staticRenderFns } from "./RadioButtonListItem.vue?vue&type=template&id=5b546412&scoped=true"
import script from "./RadioButtonListItem.vue?vue&type=script&lang=js"
export * from "./RadioButtonListItem.vue?vue&type=script&lang=js"
import style0 from "./RadioButtonListItem.vue?vue&type=style&index=0&id=5b546412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b546412",
  null
  
)

export default component.exports